const addressItemToRemoveInShipper = [
  'shipperCompanyName',
  'shipperContactPersonName',
  'shipperAddressLine1',
  'shipperAddressLine2',
  'shipperAddressLine3',
  'shipperCityName',
  'shipperPostalCode',
  'shipperCountryCode',
  'shipperCountryName',
  'shipperEmail',
  'shipperPhone',
  'shipperMobilePhone',
  'shipperNickName',
  'shippersuburb',
  'shipperProvinceCode',
  'shipperProvinceName',
];

const exportCustomerInvoiceItemsToRemoveInShipmentMapping = [
  'invoiceNumber',
  'invoiceDate',
  'invoiceExportReason',
  'invoiceIncoterm',
  'invoiceUnitOfMeasurement',
  'placeOfIncoterm',
  'lineItems',
  'noOfLineItem',
  'lineItemNumber',
  'lineItemDescription',
  'lineItemUnitPrice',
  'lineItemUnitPriceCurrency',
  'lineItemQuantity',
  'lineItemQuantityUnitofMeasurement',
  'lineItemExportCommodityCode',
  'lineItemImportCommodityCode',
  'lineItemReference',
  'lineItemPartNumber',
  'lineItemExportReasonType',
  'lineItemManufactureCountry',
  'lineItemNetWeight',
  'lineItemGrossWeight',
];

const exportCustomerInvoiceItemsToRemove = [
  'invoiceNumber',
  'invoiceDate',
  'invoiceExportReason',
  'invoiceIncoterm',
  'invoiceUnitOfMeasurement',
  'placeOfIncoterm',
  'lineItemUnitPriceCurrency',
  'lineItemQuantityUnitofMeasurement',
  'lineItemExportCommodityCode',
  'lineItemImportCommodityCode',
  'lineItemReference',
  'lineItemPartNumber',
  'lineItemExportReasonType',
];

const mandatoryLineFields = [
  'lineItemDescription',
  'lineItemUnitPrice',
  'lineItemQuantity',
  'lineItemManufactureCountry',
  'lineItemNetWeight',
  'lineItemGrossWeight',
];

const customMappingConfig = (configurationResponse, itemsToRemove) => {
  const toRemoveElements = new Set(itemsToRemove);
  return configurationResponse.filter(element => !toRemoveElements.has(element));
};

const customMappingObjectConfig = configurationResponse => {
  const toRemoveElements = new Set(exportCustomerInvoiceItemsToRemove);
  return configurationResponse.filter(item => !toRemoveElements.has(item?.field_name));
};

export {
  customMappingConfig,
  customMappingObjectConfig,
  addressItemToRemoveInShipper,
  exportCustomerInvoiceItemsToRemove,
  mandatoryLineFields,
  exportCustomerInvoiceItemsToRemoveInShipmentMapping,
};
